export default __webpack_public_path__ + "static/18_9-66e048f75724dd6e74bc73a7385b734b.png";